import { render, staticRenderFns } from "./RegisterModal.vue?vue&type=template&id=81a27aba&scoped=true"
import script from "./RegisterModal.vue?vue&type=script&lang=js"
export * from "./RegisterModal.vue?vue&type=script&lang=js"
import style0 from "./RegisterModal.vue?vue&type=style&index=0&id=81a27aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a27aba",
  null
  
)

export default component.exports